module.exports = __webpack_public_path__ + "media/images/seeds/fab-ad9b092859289ccb062634d3594547f3.jpg";